import React from 'react'
import { useTranslation } from 'react-i18next'

import { useWidgetState } from '../../WidgetWrapper'
import Dropdown from '../../../../../packages/kiti/components/navigation/Dropdown'

export const getSTATUS_OPTIONS = t => [
  { id: 10, name: t('widgets.canceled') },
  { id: 12, name: t('widgets.rejected') },
  { id: 11, name: t('widgets.approved') }
]

const StatusDropdown = ({ widget }) => {
  const { t } = useTranslation('common')
  const {
    value,
    actions: { handleChange }
  } = useWidgetState()

  if (widget?.data?.hideStatusDropdown) return false

  const STATUS_OPTIONS = getSTATUS_OPTIONS(t)

  const name = value?.status?.name || t('widgets.canceled')

  return <Dropdown label={name} onChange={handleChange('status')} options={STATUS_OPTIONS} placement="bottomRight" />
}

export default StatusDropdown
